/**
 * `components.MuiStepIcon` — completed step check color.
 * Discoverability: `MuiStepIcon`, `Stepper`, `Step`, `Mui-completed`.
 *
 * @see https://mui.com/material-ui/api/step-icon/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiStepIcon(theme: Theme): Pick<Components<Theme>, 'MuiStepIcon'> {
  return {
    MuiStepIcon: {
      styleOverrides: {
        root: {
          '&.Mui-completed': {
            color: theme.palette.success.main,
          },
        },
      },
    },
  };
}
